/**
 * 참고곡(reference songs) 관련 유틸리티.
 *
 * 플레이리스트 생성/편집 폼에서 사용되는 일괄 입력 파싱 등을 제공합니다.
 */

export interface ParsedReferenceSong {
  artist: string;
  title: string;
  vocal: 'any';
}

/**
 * 일괄 입력 텍스트를 참고곡 배열로 파싱합니다.
 *
 * 지원 구분자: " - ", " – ", " — ", 탭
 * 구분자가 없는 줄은 전체를 title로 사용하고 artist는 비움.
 * 빈 줄은 무시됩니다.
 */
export function parseBulkReferenceSongs(bulkText: string): ParsedReferenceSong[] {
  const SEPARATORS = [' - ', ' – ', ' — ', '\t'];

  const lines = bulkText
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0);

  return lines.map((line) => {
    for (const sep of SEPARATORS) {
      const parts = line.split(sep);
      if (parts.length >= 2) {
        return {
          artist: parts[0].trim(),
          title: parts.slice(1).join(sep).trim(),
          vocal: 'any' as const,
        };
      }
    }
    return { artist: '', title: line, vocal: 'any' as const };
  });
}
